@use '../../styling/colors.scss' as *;
@use '../../styling/transitions.scss' as *;

// The overly complex dance of the width and max-width has to do with the transiton.
// Without these tweaks, the parent of this element (Sidebar) will snap instead of transitioning.

.Logo {
  white-space: nowrap;
  transition: all $transition-duration ease-in-out;
  display: inline-grid;
  gap: 5px;
  grid-template-columns: 32px 90px;
  align-items: center;

  .Name {
    transition: all $transition-duration ease-in-out;

    path {
      fill: $color-white;
    }
  }

  &.isCollapsed {
    overflow: hidden;

    .Name {
      display: none;
    }

    .EggyTrademark {
      opacity: 1;
    }
  }
}
